import { useCallback } from "react";
import { notification } from "antd";
import localforage from "localforage";

export function useMiscLogic(API_URL, state) {
  const { userId, setButtonLoading } = state;

  const deleteAccount = useCallback(async () => {
    const token = await localforage.getItem("access_token");
    try {
      const response = await fetch(`${API_URL}/deleteAccount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      if (data.error) {
        notification.error({ message: data.error });
      } else {
        notification.info({
          message: "Account Deletion in Progress",
          description:
            "Your account deletion request has been received. It will be processed within 1-24 hours. This business will not be visible to users from now.",
          duration: 5,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error deleting account, please contact support",
      });
    }
  }, [API_URL]);

  const contactUsSubmit = useCallback(
    async (values) => {
      setButtonLoading(true);
      const currentDate = new Date();
      const submissionDate = currentDate.toLocaleString("en-US", {
        day: "numeric",
        month: "short",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      try {
        const response = await fetch(`${API_URL}/contactUs`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...values, userId, submissionDate }),
        });
        const data = await response.json();
        if (data.error) {
          notification.error({ message: data.error });
        } else {
          notification.success({ message: data.message });
        }
      } catch (error) {
        notification.error({ message: "Error while submitting details" });
        console.error("Error while submitting details:", error);
      } finally {
        setButtonLoading(false);
      }
    },
    [API_URL, userId, setButtonLoading]
  );

  return { deleteAccount, contactUsSubmit };
}
